import React, { useContext, useMemo, useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  ActivityIndicator,
  Pressable,
} from "react-native";
import axios from "axios";
import { useNavigation, useRoute } from "@react-navigation/native";

import Header from "../../components/Header";
import { AppContext } from "../../../App";
import { useTranslation } from "../../i18n";

const API_BASE_URL = "https://api.taxi-yaounde.com";
// const API_BASE_URL = "http://localhost:4000";

const COLORS = {
  primary: "#14B8A6",
  background: "#F7F9FA",
  card: "#FFFFFF",
  textDark: "#1C1C1E",
  textMuted: "#6B7280",
  error: "#DC2626",
  border: "#E5E7EB",
};

function yearFromDateString(value) {
  // accepts YYYY-MM-DD or DD/MM/YYYY
  if (!value) return null;
  const v = String(value).trim();
  if (!v) return null;

  const iso = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return Number(iso[1]);

  const dmy = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (dmy) return Number(dmy[3]);

  return null;
}

export default function VehicleNotFoundInfoScreen() {
  const navigation = useNavigation();
  const route = useRoute();
  const { t } = useTranslation();
  const { verification, setVerification, setFormProgress } = useContext(AppContext);
  const preVerificationId = route.params?.verificationId || null;
  const preVehicleId = route.params?.vehicleId || null;

  const identifier = (route.params?.identifier || "").toString().trim().toUpperCase();

  const [ownerType, setOwnerType] = useState("PHYSIQUE"); // PHYSIQUE | MORALE
  const [ownerNameOrCompany, setOwnerNameOrCompany] = useState("");
  const [ownerSex, setOwnerSex] = useState(""); // 'Homme / Male' | 'Femme / Female'
  const [ownerPhone, setOwnerPhone] = useState("");

  const [brand, setBrand] = useState("");
  const [otherBrand, setOtherBrand] = useState("");
  const [firstRegistrationDate, setFirstRegistrationDate] = useState("");
  const [chassisNumber, setChassisNumber] = useState("");
  const [seats, setSeats] = useState("");
  const [insuranceStickerValid, setInsuranceStickerValid] = useState(null); // boolean | null
  const [portierNumber, setPortierNumber] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");

  const [errorMessage, setErrorMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const effectiveBrand = useMemo(() => {
    if (brand === "AUTRE") return otherBrand.trim();
    return brand.trim();
  }, [brand, otherBrand]);

  // const canSubmit = useMemo(() => {
  //   if (!identifier) return false;
  //   if (!ownerNameOrCompany.trim()) return false;
  //   if (!ownerPhone.trim()) return false;
  //   if (ownerType === "PHYSIQUE" && !ownerSex) return false;
  //   if (!effectiveBrand) return false;
  //   if (!chassisNumber.trim()) return false;
  //   if (!seats.trim()) return false;
  //   if (!firstRegistrationDate.trim()) return false;
  //   if (insuranceStickerValid === null) return false;
  //   return true;
  // }, [
  //   identifier,
  //   ownerNameOrCompany,
  //   ownerPhone,
  //   ownerType,
  //   ownerSex,
  //   effectiveBrand,
  //   chassisNumber,
  //   seats,
  //   firstRegistrationDate,
  //   insuranceStickerValid,
  // ]);

  const canSubmit = useMemo(() => {
  if (!identifier) return false;
  if (!ownerNameOrCompany.trim()) return false;
  if (!ownerPhone.trim()) return false;
  if (ownerType === "PHYSIQUE" && !ownerSex) return false;
  if (!effectiveBrand) return false;
  if (!chassisNumber.trim()) return false;
  if (!seats.trim()) return false;
  if (!firstRegistrationDate.trim()) return false;
  return true;
}, [
  identifier,
  ownerNameOrCompany,
  ownerPhone,
  ownerType,
  ownerSex,
  effectiveBrand,
  chassisNumber,
  seats,
  firstRegistrationDate,
]);

  
//     const handleSubmit = async () => {
//   setErrorMessage(null);

//   // ✅ require preVerificationId (since user should have paid first)
//   if (!preVerificationId) {
//     setErrorMessage("Missing verification ID. Please restart the process from payment.");
//     return;
//   }

//   if (!canSubmit) {
//     setErrorMessage(t("common.required"));
//     return;
//   }

//   const seatsNum = Number(seats);
//   if (!Number.isFinite(seatsNum) || seatsNum <= 0) {
//     setErrorMessage(t("vehicleNotFoundForm.invalidSeats"));
//     return;
//   }

//   const year = yearFromDateString(firstRegistrationDate);
//   if (!year) {
//     setErrorMessage(t("vehicleNotFoundForm.invalidFirstRegistrationDate"));
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const ownerPayload =
//       ownerType === "MORALE"
//         ? {
//             type: "MORALE",
//             organizationName: ownerNameOrCompany.trim(),
//             phone: ownerPhone.trim(),
//             email: ownerEmail.trim() || null,
//           }
//         : {
//             type: "PHYSIQUE",
//             fullName: ownerNameOrCompany.trim(),
//             gender: ownerSex,
//             phone: ownerPhone.trim(),
//             email: ownerEmail.trim() || null,
//           };

//     const vehiclePayload = {
//       registrationNumber: identifier,
//       chassisNumber: chassisNumber.trim().toUpperCase(),
//       brand: effectiveBrand,
//       seats: seatsNum,
//       firstRegistrationDate: firstRegistrationDate.trim(),
//       firstRegistrationYear: year,
//       insuranceStickerValid: Boolean(insuranceStickerValid),
//       portierNumber: portierNumber?.trim() || null,
//     };

//     // ✅ COMPLETE the prestarted record instead of creating a new one
//     const resp = await axios.put(
//       `${API_BASE_URL}/api/verification/${preVerificationId}/complete-new-registration`,
//       {
//         owner: ownerPayload,
//         vehicle: vehiclePayload,
//         payload: {
//           ...(verification || {}),
//           vehicleNotFoundDetails: {
//             vehicle: vehiclePayload,
//             owner: ownerPayload,
//           },
//           step: "vehicle_not_found_info",
//           flowType: "NEW_REGISTRATION_PREPAY",
//           preVehicleId: preVehicleId || null,
//         },
//       }
//     );

//     const data = resp.data;

//     if (!data?.success || !data?.verificationId || !data?.vehicleId) {
//       setErrorMessage(data?.message || data?.error || t("verification.serverResponseInvalid"));
//       setIsSubmitting(false);
//       return;
//     }

//     // ✅ Update context with the same verificationId + vehicleId
//     // setVerification((prev) => ({
//     //   ...(prev || {}),
//     //   verificationId: data.verificationId,
//     //   vehicleId: data.vehicleId,
//     //   numeimma: identifier,
//     // }));

//     setVerification((prev) => ({
//       ...prev,
//       verificationId: data.verificationId,
//       vehicleId: data.vehicleId,
//       numeimma: identifier,
      
//       // Save owner details
//       owner: {
//         ...prev.owner,
//         type: ownerType,
//         ...(ownerType === "PHYSIQUE" ? {
//           firstName: ownerFirstName,
//           lastName: ownerLastName,
//           fullName: `${ownerFirstName} ${ownerLastName}`.trim(),
//           gender: ownerGender,
//         } : {
//           organizationName: ownerNameOrCompany,
//         }),
//         phone: ownerPhone,
//         email: ownerEmail,
//       },
      
//       // Save vehicle details
//       vehicle: {
//         ...prev.vehicle,
//         registrationNumber: identifier,
//         chassisNumber: chassisNumber.trim().toUpperCase(),
//         brand: effectiveBrand,
//         seats: seatsNum,
//         firstRegistrationYear: year,
//         doorNumber: portierNumber?.trim() || null,
//         insuranceStickerValid: Boolean(insuranceStickerValid),
//       },
//     }));

//     // ✅ Now continue normal flow after payment + completion
//     setFormProgress((prev) => ({
//       ...(prev || {}),
//       completedSteps: [
//         ...new Set([
//           ...(prev?.completedSteps || []),
//           "payment_screen",
//           "vehicle_not_found_info",
//           "find_immatriculation_or_chasis_number_screen",
//         ]),
//       ],
//       currentStep: "vehicle_admin_info",
//     }));

//     setIsSubmitting(false);

//     navigation.navigate("vehicle_admin_info", {
//       verificationId: data.verificationId,
//       vehicleId: data.vehicleId,
//       status: "created",
//       matchedDriver: route.params?.matchedDriver, // ✅ Forward it!
//       isDriverWorkflow: route.params?.isDriverWorkflow,
//     });
//   } catch (e) {
//     const msg =
//       e?.response?.data?.message ||
//       e?.response?.data?.error ||
//       t("vehicleNotFoundForm.serverError");

//     setErrorMessage(msg);
//     setIsSubmitting(false);
//   }
// };

// src/pages/taxi_verification_screens/VehicleNotFoundInfoScreen.js
// Add this after the successful API response in handleSubmit

const handleSubmit = async () => {
  setErrorMessage(null);

  if (!preVerificationId) {
    setErrorMessage("Missing verification ID. Please restart the process from payment.");
    return;
  }

  if (!canSubmit) {
    setErrorMessage(t("common.required"));
    return;
  }

  const seatsNum = Number(seats);
  if (!Number.isFinite(seatsNum) || seatsNum <= 0) {
    setErrorMessage(t("vehicleNotFoundForm.invalidSeats"));
    return;
  }

  const year = yearFromDateString(firstRegistrationDate);
  if (!year) {
    setErrorMessage(t("vehicleNotFoundForm.invalidFirstRegistrationDate"));
    return;
  }

  setIsSubmitting(true);

  try {
    const ownerPayload =
      ownerType === "MORALE"
        ? {
            type: "MORALE",
            organizationName: ownerNameOrCompany.trim(),
            phone: ownerPhone.trim(),
            email: ownerEmail.trim() || null,
          }
        : {
            type: "PHYSIQUE",
            fullName: ownerNameOrCompany.trim(),
            gender: ownerSex,
            phone: ownerPhone.trim(),
            email: ownerEmail.trim() || null,
          };

    const vehiclePayload = {
      registrationNumber: identifier,
      chassisNumber: chassisNumber.trim().toUpperCase(),
      brand: effectiveBrand,
      seats: seatsNum,
      firstRegistrationDate: firstRegistrationDate.trim(),
      firstRegistrationYear: year,
      insuranceStickerValid: Boolean(insuranceStickerValid),
      portierNumber: portierNumber?.trim() || null,
    };

    const resp = await axios.put(
      `${API_BASE_URL}/api/verification/${preVerificationId}/complete-new-registration`,
      {
        owner: ownerPayload,
        vehicle: vehiclePayload,
        payload: {
          ...(verification || {}),
          vehicleNotFoundDetails: {
            vehicle: vehiclePayload,
            owner: ownerPayload,
          },
          step: "vehicle_not_found_info",
          flowType: "NEW_REGISTRATION_PREPAY",
          preVehicleId: preVehicleId || null,
        },
      }
    );

    const data = resp.data;

    if (!data?.success || !data?.verificationId || !data?.vehicleId) {
      setErrorMessage(data?.message || data?.error || t("verification.serverResponseInvalid"));
      setIsSubmitting(false);
      return;
    }

    // ✅ UPDATE CONTEXT WITH ALL DATA
    setVerification((prev) => ({
      ...prev,
      verificationId: data.verificationId,
      vehicleId: data.vehicleId,
      numeimma: identifier,
      
      // Save owner details
      owner: {
        ...prev.owner,
        type: ownerType,
        ...(ownerType === "PHYSIQUE" ? {
          fullName: ownerNameOrCompany.trim(),
          gender: ownerSex,
        } : {
          organizationName: ownerNameOrCompany.trim(),
        }),
        phone: ownerPhone.trim(),
        email: ownerEmail.trim() || null,
      },
      
      // Save vehicle details
      vehicle: {
        ...prev.vehicle,
        registrationNumber: identifier,
        chassisNumber: chassisNumber.trim().toUpperCase(),
        brand: effectiveBrand,
        seats: seatsNum,
        firstRegistrationYear: year,
        doorNumber: portierNumber?.trim() || null,
        insuranceStickerValid: Boolean(insuranceStickerValid),
      },
      
      // Save the original first registration date string
      vehicleAdmin: {
        ...prev.vehicleAdmin,
        firstRegistrationDate: firstRegistrationDate.trim(),
      },
    }));

    setFormProgress((prev) => ({
      ...(prev || {}),
      completedSteps: [
        ...new Set([
          ...(prev?.completedSteps || []),
          "payment_screen",
          "vehicle_not_found_info",
          "find_immatriculation_or_chasis_number_screen",
        ]),
      ],
      currentStep: "vehicle_admin_info",
    }));

    setIsSubmitting(false);

    navigation.navigate("vehicle_admin_info", {
      verificationId: data.verificationId,
      vehicleId: data.vehicleId,
      status: "created",
      matchedDriver: route.params?.matchedDriver,
      isDriverWorkflow: route.params?.isDriverWorkflow,
    });
  } catch (e) {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      t("vehicleNotFoundForm.serverError");

    setErrorMessage(msg);
    setIsSubmitting(false);
  }
};

  const handleBack = () => {
    navigation.navigate("find_immatriculation_or_chasis_number_screen");
  };

  return (
    <View style={styles.screen}>
      <Header />
      <ScrollView contentContainerStyle={styles.scroll}>
        <Pressable style={styles.backButton} onPress={handleBack}>
          <Text style={styles.backIcon}>←</Text>
          <Text style={styles.backText}>{t("vehicleNotFoundForm.back")}</Text>
        </Pressable>

        <Text style={styles.title}>{t("vehicleNotFoundForm.title")}</Text>
        <Text style={styles.subtitle}>
          {t("vehicleNotFoundForm.subtitle")}
        </Text>

        <View style={styles.card}>
          <Text style={styles.sectionTitle}>{t("vehicleNotFoundForm.enteredIdentifierTitle")}</Text>
          <Text style={styles.readonlyValue}>{identifier || "-"}</Text>
        </View>

        <View style={styles.card}>
          <Text style={styles.sectionTitle}>{t("vehicleNotFoundForm.ownerSectionTitle")}</Text>

          <Text style={styles.label}>{t("vehicleNotFoundForm.ownerTypeLabel")}</Text>
          <View style={styles.row}>
            <Pill
              active={ownerType === "PHYSIQUE"}
              label={t("vehicleNotFoundForm.ownerTypePhysical")}
              onPress={() => {
                setOwnerType("PHYSIQUE");
              }}
            />
            <Pill
              active={ownerType === "MORALE"}
              label={t("vehicleNotFoundForm.ownerTypeCompany")}
              onPress={() => {
                setOwnerType("MORALE");
                setOwnerSex("");
              }}
            />
          </View>

          <Text style={styles.label}>
            {ownerType === "MORALE" 
              ? t("vehicleNotFoundForm.ownerNameLabelCompany") 
              : t("vehicleNotFoundForm.ownerNameLabelPhysical")}
          </Text>
          <TextInput
            value={ownerNameOrCompany}
            onChangeText={setOwnerNameOrCompany}
            placeholder={ownerType === "MORALE" 
              ? t("vehicleNotFoundForm.ownerNamePlaceholderCompany") 
              : t("vehicleNotFoundForm.ownerNamePlaceholderPhysical")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />

          {ownerType === "PHYSIQUE" && (
            <>
              <Text style={styles.label}>{t("vehicleNotFoundForm.sexLabel")}</Text>
              <View style={styles.row}>
                <Pill
                  active={ownerSex === "Homme / Male"}
                  label={t("vehicleNotFoundForm.male")}
                  onPress={() => setOwnerSex("Homme / Male")}
                />
                <Pill
                  active={ownerSex === "Femme / Female"}
                  label={t("vehicleNotFoundForm.female")}
                  onPress={() => setOwnerSex("Femme / Female")}
                />
              </View>
            </>
          )}

          <Text style={styles.label}>{t("vehicleNotFoundForm.phoneLabel")}</Text>
          <TextInput
            value={ownerPhone}
            onChangeText={setOwnerPhone}
            keyboardType="phone-pad"
            placeholder={t("vehicleNotFoundForm.phonePlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />
          <Text style={styles.label}>{t("vehicleNotFoundForm.emailLabel")}</Text>
          <TextInput
            value={ownerEmail}
            onChangeText={setOwnerEmail}
            keyboardType="email-address"
            autoCapitalize="none"
            placeholder={t("vehicleNotFoundForm.emailPlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />
        </View>

        <View style={styles.card}>
          <Text style={styles.sectionTitle}>{t("vehicleNotFoundForm.vehicleSectionTitle")}</Text>

          <Text style={styles.label}>{t("vehicleNotFoundForm.brandLabel")}</Text>
          <View style={styles.rowWrap}>
            {[
              "TOYOTA",
              "NISSAN",
              "HYUNDAI",
              "KIA",
              "PEUGEOT",
              "RENAULT",
              "AUTRE",
            ].map((b) => (
              <Pill
                key={b}
                active={brand === b}
                label={b === "AUTRE" ? t("vehicleNotFoundForm.brandOther") : b}
                onPress={() => setBrand(b)}
              />
            ))}
          </View>

          {brand === "AUTRE" && (
            <>
              <Text style={styles.label}>{t("vehicleNotFoundForm.specifyBrandLabel")}</Text>
              <TextInput
                value={otherBrand}
                onChangeText={setOtherBrand}
                placeholder={t("vehicleNotFoundForm.specifyBrandPlaceholder")}
                placeholderTextColor="#9CA3AF"
                style={styles.input}
              />
            </>
          )}

          <Text style={styles.label}>{t("vehicleNotFoundForm.firstRegistrationDateLabel")}</Text>
          <TextInput
            value={firstRegistrationDate}
            onChangeText={setFirstRegistrationDate}
            placeholder={t("vehicleNotFoundForm.firstRegistrationDatePlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />

          <Text style={styles.label}>{t("vehicleNotFoundForm.chassisLabel")}</Text>
          <TextInput
            value={chassisNumber}
            onChangeText={setChassisNumber}
            autoCapitalize="characters"
            placeholder={t("vehicleNotFoundForm.chassisPlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />

          <Text style={styles.label}>{t("vehicleNotFoundForm.seatsLabel")}</Text>
          <TextInput
            value={seats}
            onChangeText={setSeats}
            keyboardType="number-pad"
            placeholder={t("vehicleNotFoundForm.seatsPlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />
        {/* Will be implemented later */}
          <Text style={styles.label}>{t("vehicleNotFoundForm.portierNumberLabel")}</Text>
          <TextInput
            value={portierNumber}
            onChangeText={setPortierNumber}
            placeholder={t("vehicleNotFoundForm.portierNumberPlaceholder")}
            placeholderTextColor="#9CA3AF"
            style={styles.input}
          />

          <Text style={styles.label}>{t("vehicleNotFoundForm.insuranceStickerLabel")}</Text>
          <View style={styles.row}>
            <Pill
              active={insuranceStickerValid === true}
              label={t("vehicleNotFoundForm.yes")}
              onPress={() => setInsuranceStickerValid(true)}
            />
            <Pill
              active={insuranceStickerValid === false}
              label={t("vehicleNotFoundForm.no")}
              onPress={() => setInsuranceStickerValid(false)}
            />
          </View>
        </View>

        {errorMessage ? <Text style={styles.errorText}>{errorMessage}</Text> : null}

        <TouchableOpacity
          onPress={handleSubmit}
          disabled={!canSubmit || isSubmitting}
          style={[styles.cta, (!canSubmit || isSubmitting) && { opacity: 0.5 }]}
        >
          {isSubmitting ? (
            <ActivityIndicator color="#FFF" />
          ) : (
            <Text style={styles.ctaText}>{t("vehicleNotFoundForm.submit")}</Text>
          )}
        </TouchableOpacity>

        <View style={{ height: 30 }} />
      </ScrollView>
    </View>
  );
}

function Pill({ active, label, onPress }) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.pill, active && styles.pillActive]}
    >
      <Text style={[styles.pillText, active && styles.pillTextActive]}>{label}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1, backgroundColor: COLORS.background },
  scroll: { paddingHorizontal: 16, paddingBottom: 40 },
  backButton: {
    flexDirection: "row",
    alignItems: "center",
    width: 120,
    height: 42,
    borderRadius: 12,
    backgroundColor: "#fff",
    paddingHorizontal: 12,
    marginBottom: 8,
    marginTop: 16,
  },
  backIcon: { fontSize: 18, color: COLORS.textDark, marginRight: 6 },
  backText: { fontSize: 14, color: COLORS.textDark, fontWeight: "600" },
  title: { fontSize: 22, fontWeight: "800", textAlign: "center", marginBottom: 6, color: COLORS.textDark },
  subtitle: { 
    textAlign: "center", 
    color: COLORS.textMuted, 
    marginBottom: 18,
    fontSize: 14,
    lineHeight: 20,
  },
  card: {
    backgroundColor: COLORS.card,
    borderRadius: 16,
    padding: 16,
    borderWidth: 1,
    borderColor: COLORS.border,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  sectionTitle: { 
    fontSize: 16, 
    fontWeight: "800", 
    marginBottom: 12, 
    color: COLORS.textDark,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.border,
    paddingBottom: 8,
  },
  readonlyValue: { fontSize: 16, fontWeight: "700", color: COLORS.textDark },
  label: { 
    marginTop: 10, 
    marginBottom: 6, 
    color: COLORS.textMuted, 
    fontWeight: "600",
    fontSize: 13,
  },
  input: {
    borderWidth: 1,
    borderColor: COLORS.border,
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: "#F9FAFB",
    color: COLORS.textDark,
    height: 48,
    fontSize: 14,
  },
  row: { flexDirection: "row", gap: 10, marginTop: 6, flexWrap: "wrap" },
  rowWrap: { flexDirection: "row", gap: 10, marginTop: 6, flexWrap: "wrap" },
  pill: {
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: COLORS.border,
    backgroundColor: "#fff",
  },
  pillActive: { backgroundColor: COLORS.primary, borderColor: COLORS.primary },
  pillText: { color: COLORS.textDark, fontWeight: "700", fontSize: 14 },
  pillTextActive: { color: "#fff" },
  errorText: { 
    color: COLORS.error, 
    textAlign: "center", 
    marginTop: 8, 
    marginBottom: 6,
    fontSize: 12,
  },
  cta: {
    marginTop: 20,
    backgroundColor: COLORS.primary,
    paddingVertical: 16,
    borderRadius: 14,
    alignItems: "center",
    shadowColor: COLORS.primary,
    shadowOpacity: 0.2,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 4 },
    elevation: 4,
  },
  ctaText: { color: "#fff", fontWeight: "800", fontSize: 16 },
});